import { jsx } from "react/jsx-runtime";
import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
import { validateTidalLicense } from "../../base/index.js";
function PanToolAlt(props) {
  return /* @__PURE__ */ jsx(
    PanToolAltIcon,
    {
      "data-testid": "PanToolAlt",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PanToolAlt",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
PanToolAlt.tidalIconMeta = {
  categories: "map,location,time",
  name: "PanToolAlt"
};
validateTidalLicense();
export {
  PanToolAlt
};
//# sourceMappingURL=PanToolAlt.js.map
